/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export function toDateTimeLocalValue(value: string): string {
    if (value === 'NOW') {
        return '';
    }

    return value.replace(' ', 'T').slice(0, 16);
}

export function toApiDateTimeValue(value: string): string {
    return `${value.replace('T', ' ')}:00`;
}

export function formatImportedAt(
    value: string,
    locale = 'de-DE',
    unknownText = 'Unknown',
): string {
    if (!value) {
        return unknownText;
    }

    const parsedDate = new Date(value);

    if (Number.isNaN(parsedDate.getTime())) {
        return value;
    }

    return parsedDate.toLocaleString(locale);
}

/** Formats API KPI timestamps according to the selected application locale. */
export function formatKpiDateTime(value: string, locale: string): string {
    if (!value) {
        return value;
    }

    // Last-value responses use Unix milliseconds; series responses use local date strings.
    const timestamp = value.trim();
    const parsedDate = /^-?\d{13}$/.test(timestamp)
        ? new Date(Number(timestamp))
        : /^-?\d{10}(?:\.\d+)?$/.test(timestamp)
            ? new Date(Number(timestamp) * 1000)
            : new Date(value.replace(' ', 'T'));

    if (Number.isNaN(parsedDate.getTime())) {
        return value;
    }

    return parsedDate.toLocaleString(locale);
}

export function formatUnixTimestampMs(
    value: string,
    locale = 'de-DE',
    unknownText = 'Unknown',
): string {
    if (!value) {
        return unknownText;
    }

    const timestamp = Number(value);

    if (!Number.isFinite(timestamp)) {
        return value;
    }

    const parsedDate = new Date(timestamp);

    if (Number.isNaN(parsedDate.getTime())) {
        return value;
    }

    return parsedDate.toLocaleString(locale);
}
